import { css, cx } from '@bts-web/utils-style-engine';
import { iconWrapper } from './iconWrapper';

export const SunsetIcon = ({
  ariaLabel,
  onClick,
}: {
  ariaLabel: string;
  onClick?: () => void;
}) => (
  <span
    className={cx(
      iconWrapper(!!onClick),
      css({ color: 'warning.fill_primary' }),
    )}
    data-element="icon"
    aria-label={ariaLabel}
    onClick={onClick}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="white" />
      <path
        d="M6.52959 10.7992C6.47278 10.5458 6.44281 10.2823 6.44281 10.0117C6.44281 8.03166 8.04794 6.42652 10.028 6.42652C12.008 6.42652 13.6131 8.03166 13.6131 10.0117C13.6131 10.2823 13.5832 10.5458 13.5264 10.7992H15.9996C16.2205 10.7992 16.3996 10.9783 16.3996 11.1992C16.3996 11.4202 16.2205 11.5992 15.9996 11.5992H3.99961C3.7787 11.5992 3.59961 11.4202 3.59961 11.1992C3.59961 10.9783 3.7787 10.7992 3.99961 10.7992H6.52959ZM10.1076 16.3992C10.0793 16.4056 10.0499 16.4089 10.0197 16.4089C9.98952 16.4089 9.9601 16.4056 9.93182 16.3992H10.1076ZM6.06058 5.50446L6.00518 5.45818C5.84928 5.35018 5.63374 5.36561 5.49489 5.50446C5.33868 5.66067 5.33868 5.91394 5.49489 6.07015L6.18154 6.7568L6.23694 6.80308C6.39284 6.91108 6.60838 6.89565 6.74723 6.7568C6.90344 6.60059 6.90344 6.34732 6.74723 6.19112L6.06058 5.50446ZM14.5905 6.01475C14.6985 5.85886 14.6831 5.64332 14.5442 5.50446C14.388 5.34825 14.1347 5.34825 13.9785 5.50446L13.2919 6.19112L13.2456 6.24651C13.1376 6.40241 13.153 6.61795 13.2919 6.7568C13.4481 6.91301 13.7014 6.91301 13.8576 6.7568L14.5442 6.07015L14.5905 6.01475ZM10.4159 3.94687C10.382 3.76027 10.2187 3.61877 10.0223 3.61877C9.80143 3.61877 9.62234 3.79786 9.62234 4.01877V4.98985L9.62879 5.06175C9.66265 5.24835 9.82597 5.38985 10.0223 5.38985C10.2433 5.38985 10.4223 5.21076 10.4223 4.98985V4.01877L10.4159 3.94687ZM8.79961 14.7992C8.5787 14.7992 8.39961 14.9783 8.39961 15.1992C8.39961 15.4202 8.5787 15.5992 8.79961 15.5992H11.1996C11.4205 15.5992 11.5996 15.4202 11.5996 15.1992C11.5996 14.9783 11.4205 14.7992 11.1996 14.7992H8.79961ZM5.99961 13.1992C5.99961 12.9783 6.1787 12.7992 6.39961 12.7992H13.5996C13.8205 12.7992 13.9996 12.9783 13.9996 13.1992C13.9996 13.4202 13.8205 13.5992 13.5996 13.5992H6.39961C6.1787 13.5992 5.99961 13.4202 5.99961 13.1992Z"
        fill="currentColor"
      />
    </svg>
  </span>
);
